<div *ngIf="(viewType == null || viewType == 'List') && !isUnknownStatus">
  <div class="col-md-2 col-sm-6 battery-list sp-gdo-type" [ngClass]="{'flat-battery-list': flatBattery}">
    {{batteryStatusLocale}}
    <img *ngIf="this.batteryVoltage" [src]="batteryIcon" alt="batter-status.png" class="img-battery-list"
         [ngClass]="{'flat-img-battery-list': flatBattery}" title='{{batteryStatusLocale}}'>
  </div>
<!--  <div class="col-md-6 col-sm-6 sp-battery-img">-->
<!--    <img *ngIf="this.batteryVoltage" [src]="batteryIcon" alt="batter-status.png" class="battery-list"-->
<!--         title='{{batteryStatusLocale}}'>-->
<!--    <div *ngIf="!this.batteryVoltage">-->
<!--      N/A-->
<!--    </div>-->
<!--  </div>-->
</div>
<div *ngIf="(viewType == null || viewType == 'Grid') && !isUnknownStatus">
  <div class="sp-gdo-battery-grid-full" [ngClass]="{'medium-battery-grid': mediumBattery, 'flat-battery-grid' : flatBattery}">
    {{batteryStatusLocale}}
  </div>
  <div class="sp-gdo-battery-img-grid">
    <img *ngIf="this.batteryVoltage" [src]="batteryIcon" alt="battery" class="battery-grid"
         title='{{batteryStatusLocale}}'>
    <div *ngIf="!this.batteryVoltage">
      N/A
    </div>
  </div>
</div>
